import {
  ME_REQUEST,
  ME_SUCCESS,
  ME_FAILURE,
  SESSION_ANONYMOUS,
  CLEAR_PROFILE,
} from "./actionTypes";

const initialState = {
  // 'idle' | 'loading' | 'authenticated' | 'anonymous' | 'error'
  //
  // 'anonymous' means the SERVER said there is no session (401/403) — only that
  // may send the user to /login. 'error' means we could not reach the server at
  // all; the session may well be fine, so we show a retry instead of signing out.
  status: "idle",
  user: null,
  permissions: [],
  is_super_admin: false,
  error: null,
};

const profile = (state = initialState, action) => {
  switch (action.type) {
    case ME_REQUEST:
      return { ...state, status: "loading", error: null };

    case ME_SUCCESS: {
      const { user, permissions } = action.payload;
      return {
        ...state,
        status: "authenticated",
        user,
        permissions: Array.isArray(permissions) ? permissions : [],
        is_super_admin: Boolean(user && user.is_super_admin),
        error: null,
      };
    }

    case ME_FAILURE:
      // Transport failure only (the saga routes 401/403 to SESSION_ANONYMOUS).
      // Previously this fell back to "anonymous" whenever `state.user` was null —
      // which is ALWAYS the case on the two paths that call fetchMe (app bootstrap
      // and immediately after login), so every blip was spelled "logged out".
      return { ...state, status: state.user ? "authenticated" : "error", error: action.payload };

    case SESSION_ANONYMOUS:
      return { ...initialState, status: "anonymous" };

    case CLEAR_PROFILE:
      return { ...initialState, status: "anonymous" };

    default:
      return state;
  }
};

export default profile;
